import glamorous from 'glamorous';

const Message = glamorous.div({
  width: '100%',
  fontSize: '2.5rem',
  margin: '1.2rem 0',
  padding: '30px 25px',
  textAlign: 'center',
  position: 'relative',
  ':before': {
    content: ' ',
    backgroundColor: 'rgba(0,0,0,0.3)',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});

export default Message;



// WEBPACK FOOTER //
// ./src/App/events/components/Message.js